// ENTITY fr.gestionpial.pial.dto.RemplacementEcoleDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { RemplacementAeshDTO } from './RemplacementAeshDTO';

export class RemplacementEcoleDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.RemplacementEcoleDTO';

  idEcole: number | null = 0;
  nomEcole: string | null = '';
  volumeACouvrir: number | null = 0;
  aeshsDisponibles: RemplacementAeshDTO[] | null = [];

  constructor(init?:Partial<RemplacementEcoleDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.RemplacementEcoleDTO'] = RemplacementEcoleDTO;

fields['fr.gestionpial.pial.dto.RemplacementEcoleDTO']  = {
    idEcole: 'java.lang.Integer',
    nomEcole: 'java.lang.String',
    volumeACouvrir: 'java.lang.Integer',
    aeshsDisponibles: 'java.util.List<fr.gestionpial.pial.dto.RemplacementAeshDTO>'
};
